import { MultiplePagesEmpty } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconMultiplePagesEmpty12Line = createIcon(
  MultiplePagesEmpty,
  12,
  "Line"
);
export const IconMultiplePagesEmpty16Line = createIcon(
  MultiplePagesEmpty,
  16,
  "Line"
);
export const IconMultiplePagesEmpty20Line = createIcon(
  MultiplePagesEmpty,
  20,
  "Line"
);
export const IconMultiplePagesEmpty24Line = createIcon(
  MultiplePagesEmpty,
  24,
  "Line"
);
export const IconMultiplePagesEmpty32Line = createIcon(
  MultiplePagesEmpty,
  32,
  "Line"
);
export const IconMultiplePagesEmpty48Line = createIcon(
  MultiplePagesEmpty,
  48,
  "Line"
);
export const IconMultiplePagesEmpty64Line = createIcon(
  MultiplePagesEmpty,
  64,
  "Line"
);
